module.exports = [{
      plugin: require('/srv/awa/gatsby/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"theme":{"typography":{"useNextVariants":true,"fontFamily":"'Exo 2', sans-serif"},"palette":{"primary":{"main":"#1e87da"},"secondary":{"main":"#ffaa00"}},"overrides":{"MuiTypography":{"h1":{"fontWeight":100},"h2":{"fontWeight":100}}}}},
    },{
      plugin: require('/srv/awa/gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
